export default __webpack_public_path__ + "static/media/Evelyn.027bc6ee.jpg";